import { useAuthenticationInternal } from '@pflegenavi/frontend/authentication';
import { getGlobalServiceProviderIdFromToken } from '../utils/getGlobalServiceProviderIdFromToken';

export const useGetGlobalServiceProviderId = (): {
  globalServiceProviderId: string;
} => {
  const { getTokenImmediate } = useAuthenticationInternal();

  const globalServiceProviderId = getGlobalServiceProviderIdFromToken(
    getTokenImmediate()
  );

  if (!globalServiceProviderId) {
    throw new Promise((resolve) => {
      // This promise will be caught by React Suspense
      // and resolved when the token is available
      setTimeout(resolve, 20);
    });
  }

  return { globalServiceProviderId };
};
